const archivePlaybackTutorial = {
  module: 'archive_playback',
  moduleName: 'Archive Playback',
  steps: [
    { target: '.archive-sidebar', position: 'right', title: 'Camera List', description: 'Select a camera to review its recorded footage.' },
    { target: '.archive-layout', position: 'top', title: 'Playback View', description: 'Watch archived video with timeline scrubbing and playback controls.' },
    { target: '.page-subtitle', position: 'bottom', title: 'Archive', description: 'Archive lets you review any moment in time across all your cameras.' },
  ],
};
export default archivePlaybackTutorial;
